interface Props {
  dateUTC: string
}

const DateComponent: React.FC<Props> = ({ dateUTC }) => {
  return (
    <>
      {new Date(dateUTC).getDate() +
        '/' +
        (new Date(dateUTC).getMonth() + 1) +
        '/' +
        new Date(dateUTC).getFullYear()}
    </>
  )
}

export default DateComponent
